import React from "react";
import i18n from "micro-i18n";
import PropTypes from "prop-types";
import { IconCSLogo, IconCSLogoDark } from "components/icons/Icons";
import classNames from "classnames";
import { isNullOrUndefOrEmpty } from "utils";

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/poll-by/PollBy.scss';

const PollByContent = () => {
  return (
    <>
      <span className="csw-poll-by-txt">{i18n.t("POLL_BY_CIVICSCIENCE")}</span>
      <IconCSLogoDark />
      <IconCSLogo />
    </>
  );
};

const PollBy = ({ id, partnerName, className, hasTooltip = false }) => {
  return (
    <div className={classNames(`csw-poll-by csw-poll-by-bottom-right`, className)} id={id}>
      <div className={hasTooltip ? "csw-poll-by-tooltip" : "csw-poll-by-no-tooltip"}>
        <div
          className="csw-poll-by-content"
          aria-describedby={hasTooltip ? `${id}-tooltip-text` : undefined}
          data-testid={`${id}-text`}
        >
          <PollByContent />
        </div>

        {hasTooltip && (
          <div className="csw-poll-by-tooltip-text" role="tooltip" id={`${id}-tooltip-text`}>
            <strong className="csw-poll-by-tooltip-text-title">{i18n.t("POLL_BY_TOOLTIP_TITLE")}</strong>
            <div className="csw-poll-by-tooltip-text-desc">
              {i18n.t(isNullOrUndefOrEmpty(partnerName) ? "POLL_BY_TOOLTIP_DESC_NO_PARTNER" : "POLL_BY_TOOLTIP_DESC", {
                partnerName,
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

PollBy.propTypes /* remove-proptypes */ = {
  id: PropTypes.string.isRequired,
  partnerName: PropTypes.string,
  className: PropTypes.string,
  hasTooltip: PropTypes.bool,
};

export default PollBy;
